import { waitForTarget } from '@rambler-id/promise';
import { createDebug } from '@rambler-id/debug';
const debug = createDebug('common:metrics:top100');
export const activateTop100 = ({ isMainCounter = true, ...options }) => {
    /* eslint-disable */
    return new Promise((resolve) => {
        if (process.env.NODE_ENV === 'development') {
            resolve();
            return;
        }
        /* eslint-disable */
        // prettier-ignore
        ;
        (function (w, d, c) {
            // @ts-ignore
            (w[c] = w[c] || []).push(function () {
                try {
                    const counterKeys = Array.isArray(options.counterKey) ? options.counterKey : [options.counterKey];
                    counterKeys.forEach((key, i) => {
                        // @ts-ignore
                        const counter = new top100({
                            project: key,
                            attributes_dataset: options.dataset,
                            ...options.params
                        });
                        // @ts-ignore
                        w[`top100Counter${key}`] = counter;
                        if (isMainCounter && i === 0) {
                            // @ts-ignore
                            w.top100Counter = counter;
                        }
                    });
                }
                catch (e) {
                }
            });
            // @ts-ignore
            var n = d.getElementsByTagName("script")[0], s = d.createElement("script"), f = function () { n.parentNode.insertBefore(s, n); };
            s.type = "text/javascript";
            s.async = true;
            s.src =
                (d.location.protocol == "https:" ? "https:" : "http:") +
                    "//st.top100.ru/top100/top100.js";
            s.onload = () => resolve();
            s.onerror = () => resolve();
            // @ts-ignore
            if (w.opera == "[object Opera]") {
                d.addEventListener("DOMContentLoaded", f, false);
            }
            else {
                f();
            }
        })(window, document, "_top100q");
        /* eslint-enable */
    });
};
export const createSendCustomVars = (counterKey) => async (params) => {
    if (process.env.NODE_ENV === 'development') {
        debug(`sendCustomVars ${counterKey} %o`, params);
        return;
    }
    try {
        const counterKeys = Array.isArray(counterKey) ? counterKey : [counterKey];
        const counters = await Promise.all(counterKeys.map((key) => waitForTarget(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => window[`top100Counter${key}`], 1000)));
        counters.forEach((counter) => counter.sendCustomVars(params));
    }
    catch { }
};
export const createTrackPageview = (counterKey) => async () => {
    if (process.env.NODE_ENV === 'development') {
        debug('trackPageview');
        return;
    }
    try {
        const counterKeys = Array.isArray(counterKey) ? counterKey : [counterKey];
        const counters = await Promise.all(counterKeys.map((key) => waitForTarget(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => window[`top100Counter${key}`], 1000)));
        counters.forEach((counter) => counter.trackPageview());
    }
    catch { }
};
export const createTrackEvent = (counterKey) => async (eventName, eventData) => {
    if (process.env.NODE_ENV === 'development') {
        debug(`trackEvent, ${eventName}, %o`, eventData);
        return;
    }
    try {
        const counterKeys = Array.isArray(counterKey) ? counterKey : [counterKey];
        const counters = await Promise.all(counterKeys.map((key) => waitForTarget(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => window[`top100Counter${key}`], 1000)));
        counters.forEach((counter) => counter.trackEvent(eventName, eventData));
    }
    catch { }
};
export const createUpdateOptions = (counterKey) => async (options) => {
    if (process.env.NODE_ENV === 'development') {
        debug(`updateOptions, ${options}`);
        return;
    }
    try {
        const counterKeys = Array.isArray(counterKey) ? counterKey : [counterKey];
        const counters = await Promise.all(counterKeys.map((key) => waitForTarget(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        () => window[`top100Counter${key}`], 1000)));
        counters.forEach((counter) => counter.updateOptions(options));
    }
    catch { }
};
